import React, { useContext } from "react";
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import './style/login.css';
import logo from './assets/logo.png'
import firebaseApp from './firebaseApp';
import firebase from "firebase"
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { withRouter, Redirect } from "react-router";
import { AuthContext } from "./Auth.js";

    


function SignIn(){ 
    
    const uiConfig = {
        signInFlow: "popup",
        signInOptions:[{
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            scopes: ["https://www.googleapis.com/auth/gmail.modify"]
        }],
        //signInSuccessUrl: "/dashboard"
    }

    return (
        <div className="signIn">
            <StyledFirebaseAuth className="btnSigin" uiConfig={uiConfig} firebaseAuth={firebaseApp.auth()}/>
        </div>
    );
}

function Copyright() {
    return (
        <Typography variant="body2" color="textPrimary" align="center">
            <b>{'Copyright © '}
            <Link href="https://isitphishy.wixsite.com/website" target="_blank">
                Phishy
            </Link>{' '}
            {new Date().getFullYear()}</b>
            {'.'}
        </Typography>
    );
}

function Loginn() {
    const { currentUser } = useContext(AuthContext);
    
    if (currentUser) 
    {
        console.log("inside current user");
        //get database
        const db = firebaseApp.firestore()
        
        //get users email
        const user = firebaseApp.auth().currentUser;    
        if (user != null) {
            var email = user.email;
        }
        
        //get collection
        var eventRef = db.collection('events').doc(email);
        eventRef.get().then(function(doc)
        {
            //if user exists in our database
            if(!doc.exists)
            {
                
                console.log("new user");
                return <Redirect to="/newUserSetup" />;
            }
            else
            {
                console.log("existing user");
                return <Redirect to="/dashboard" />;
            }
            
        })
    } 
    return (
        <div className="contentContainer">
            <div className="loginSectionContent">
                <img src={logo} className="App-logo" alt="logo"/><br />
                <p className="pageHeader">Login</p> 
                <hr />
                <br />
                <SignIn />

                <Box mt={8}>
                    <Copyright />
                </Box>
            </div>
        </div>

    );
}

export default withRouter(Loginn);
